var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.833008C22.517 0.832996 25.0094 1.32875 27.3348 2.29196C29.6602 3.25516 31.7731 4.66697 33.5529 6.44675C35.3327 8.22654 36.7445 10.3395 37.7078 12.6649C38.671 14.9903 39.1667 17.4826 39.1667 19.9996C39.1667 30.5851 30.5855 39.1664 20 39.1664C9.41462 39.1664 0.833374 30.5851 0.833374 19.9996C0.833374 9.41425 9.41462 0.833008 20 0.833008ZM21.9167 21.9164H18.0834C13.3383 21.9164 9.26449 24.7902 7.50742 28.8926C10.2875 32.791 14.8469 35.333 20 35.333C25.1531 35.333 29.7125 32.791 32.4927 28.8923C30.7356 24.7902 26.6618 21.9164 21.9167 21.9164ZM20 6.58301C16.8244 6.58301 14.25 9.15739 14.25 12.333C14.25 15.5086 16.8244 18.083 20 18.083C23.1756 18.083 25.75 15.5086 25.75 12.333C25.75 9.15739 23.1757 6.58301 20 6.58301Z",
    fill: "#007DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user-logo.b241bff97f50cc34c308ae24e82e0867.svg";
export { ForwardRef as ReactComponent };